//车场管理
const ParkingParklist = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parklist.vue"
  );
const AbnormalRelease = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/abnormalRelease.vue"
  );
const ParkingIORecordList = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/ioRecordList.vue"
  );
const PresenceRecord = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/presenceRecord.vue"
  );
const ParkingSpace = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parking-space/parking-space.vue"
  );
const ParkingSpaceAudit = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parking-space/space-audit.vue"
  );
const SpaceReservationRecord = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/space-reservation-record/space-reservation-record.vue"
  );
const UpdateParkingChargeRule = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parking-charge-rule/update-parking-charge-rule/update-parking-charge-rule.vue"
  );
const ParkingChargeRule = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parking-charge-rule/parking-charge-rule.vue"
  );
//共享停车订单记录
const ShareOrderRecord = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/share-order-record/share-order-record.vue"
  );

const ShareSpaceSetting = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parking-space/setting.vue"
  );
const SharePendingSpace = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parking-space/pending-space.vue"
  );

const SharePendingDeleteSpace = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parking-space/pending-delete-space.vue"
  );

const SharePendingAuditSpace = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/parking-space/pending-audit-space.vue"
  );

const ShareCompanySpace = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/company-parking-space/company-parking-space.vue"
  );
const ShareSpaceCollectionOpinions = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/parkingManagement/collection-opinions/collection-opinions.vue"
  );

const ShareAppointmentRule = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/share-appointment-rule/share-appointment-rule.vue"
  );

const SharePaymentConfig = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/share-payment-config/share-payment-config.vue"
  );

  //共享预约记录
  const ShareAppointmentRecord = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/share-appointment-record/share-appointment-record.vue"
  );
  //共享超时订单
const ShareTimeoutOrder = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/share-timeout-order/share-timeout-order.vue"
  );
  //共享分账记录
const ShareSplitPaymentRecord = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/share-split-payment-record/share-split-payment-record.vue"
  );
const RouteTemp = () =>
  import(/*webpackChunkName:'operation'*/ "@/page/commons/routeTemp.vue");

export const parkingManagement = {
  path: "/main/park",
  name: "车场管理",
  meta: {
    requireAuth: true,
  },
  component: RouteTemp,
  children: [
    {
      path: "/main/park/iorecordlist",
      name: "进出记录",
      meta: {
        requireAuth: true,
      },
      component: ParkingIORecordList,
    },
    {
      path: "/main/park/parkingParklist",
      name: "车场管理",
      meta: {
        requireAuth: true,
      },
      component: ParkingParklist,
    },
    {
      path: "/main/park/presenceRecord",
      name: "在场记录",
      meta: {
        requireAuth: true,
      },
      component: PresenceRecord,
    },

    {
      path: "/main/park/abnormalRelease",
      name: "异常放行记录",
      meta: {
        requireAuth: true,
      },
      component: AbnormalRelease,
    },
    {
      path: "/main/park/share-appointment-rule",
      name: "预约规则",
      meta: {
        requireAuth: true,
      },
      component: ShareAppointmentRule,
    },
    {
      path: "/main/park/parking-space",
      name: "个人车位",
      meta: {
        requireAuth: true,
      },
      component: ParkingSpace,
    },
    {
      path: "/main/park/company-space",
      name: "企业车位",
      meta: {
        requireAuth: true,
      },
      component: ShareCompanySpace,
    },
    {
      path: "/main/park/parking-space/audit",
      name: "车位审核",
      meta: {
        requireAuth: true,
      },
      component: ParkingSpaceAudit,
    },
    {
      path: "/main/park/parking-space/delete",
      component: SharePendingDeleteSpace,
      name: "待删除车位",
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/park/parking-space/audit-pending",
      component: SharePendingAuditSpace,
      name: "待审核车位",
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/park/parking-space/setting",
      name: "设置",
      meta: {
        requireAuth: true,
      },
      component: ShareSpaceSetting,
    },
    {
      path: "/main/park/parking-space/pending",
      name: "信息未完善车位",
      meta: {
        requireAuth: true,
      },
      component: SharePendingSpace,
    },
    {
      path: "/main/park/share-appointment-record",
      name: "预约记录",
      meta: {
        requireAuth: true,
      },
      component: ShareAppointmentRecord,
    },
    {
      path: "/main/park/parking-charge-rule",
      name: "收费规则",
      meta: {
        requireAuth: true,
      },
      component: ParkingChargeRule,
    },
    {
      path: "/main/park/parking-charge-rule/update",
      name: "共享收费规则",
      meta: {
        requireAuth: true,
      },
      component: UpdateParkingChargeRule,
    },
    {
      path: "/main/park/share-order-record",
      name: "停车订单",
      meta: {
        requireAuth: true,
      },
      component: ShareOrderRecord,
    },
     {
      path: "/main/park/share-timedout-order",
      name: "超时订单",
      meta: {
        requireAuth: true,
      },
      component: ShareTimeoutOrder,
    },
    {
      path: "/main/park/share-split-payment-record",
      name: "分账记录",
      meta: {
        requireAuth: true,
      },
      component: ShareSplitPaymentRecord,
    },
    {
      path: "/main/park/share-payment-config",
      name: "支付配置",
      meta: {
        requireAuth: true,
      },
      component: SharePaymentConfig,
    },
    {
      path: "/main/park/share-space-collection-opinions",
      name: "共享意见征集",
      meta: {
        requireAuth: true,
      },
      component: ShareSpaceCollectionOpinions,
    },
  ],
};
